import { render, staticRenderFns } from "./notFound.vue?vue&type=template&id=0c72302d&scoped=true"
import script from "./notFound.ts?vue&type=script&lang=ts&external"
export * from "./notFound.ts?vue&type=script&lang=ts&external"
import style0 from "./notFound.vue?vue&type=style&index=0&id=0c72302d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c72302d",
  null
  
)

export default component.exports